import Icon from '../components/Icon.vue'

Icon.register({"map-signs":{"width":1792,"height":1792,"paths":[{"d":"M1745 297q10 10 10 23t-10 23l-141 141q-28 28-68 28h-1344q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h576v-64q0-26 19-45t45-19h128q26 0 45 19t19 45v64h512q40 0 68 28zM768 1216h256v512q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-512zM1600 768q26 0 45 19t19 45v256q0 26-19 45t-45 19h-1344q-40 0-68-28l-141-141q-10-10-10-23t10-23l141-141q28-28 68-28h512v-192h256v192h576z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map-signs.js
// module id = 460
// module chunks = 0